module.exports = __webpack_public_path__ + "media/images/pic/materials/hiragana-3b305f90af8a916714da1b3891372d6f.png";